import http from '../../http'

const API_URL = "cc_minus_ten"

class CommitteeAPI {

  async save(committee) {
    const response = await http(`${API_URL}/save`, 'POST', committee)
    return response || null
  }

  async getCommittee(companyID) {
    const response = await http(`${API_URL}/companies/${companyID}`, 'GET')
    return response || null
  }

  async printComittee(companyID) {
    const response = await http(`${API_URL}/companies/print/${companyID}`, 'GET')
    return response || null
  }

}

export default new CommitteeAPI()